import React, { useState, useEffect } from "react"
import { QRCodeSVG } from "qrcode.react"
import { useAuthStore } from "../store/store"

function DepositTab() {
  const { getAccount, updateAccount, user } = useAuthStore()
  const [accountNumber, setAccountNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  const [copied, setCopied] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const fetchAccountDetails = async () => {
      try {
        const response = await getAccount();
        if (response?.data) {
          setAccountNumber(response.data[0].accountNumber);
          setBankName(response.data[0].bankName);
          setAccountHolder(response.data[0].accountHolder);
        }
      } catch (error) {
        console.error("Error fetching account details:", error);
      }
    };
    fetchAccountDetails();
  }, []);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(accountNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleSave = async () => {
    try {
      const updatedData = { accountNumber, bankName, accountHolder };
      await updateAccount(updatedData);
      setIsEditing(false);
      alert("Account details updated successfully!");
    } catch (error) {
      console.error("Error updating account details:", error);
    }
  };

  if (user?.accountType !== "user") {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center w-96">
          <h2 className="text-2xl font-bold mb-4">My Account</h2>

          <div className="flex justify-center mb-4">
            <QRCodeSVG value={accountNumber} size={150} />
          </div>

          <label className="text-gray-700 font-semibold">Bank Name:</label>
          <input
            type="text"
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
            className="border p-2 mb-2 w-full rounded-lg"
            disabled={!isEditing}
          />

          <label className="text-gray-700 font-semibold">Account Holder:</label>
          <input
            type="text"
            value={accountHolder}
            onChange={(e) => setAccountHolder(e.target.value)}
            className="border p-2 mb-2 w-full rounded-lg"
            disabled={!isEditing}
          />

          <label className="text-gray-700 font-semibold">Account Number:</label>
          <input
            type="text"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
            className="border p-2 mb-2 w-full rounded-lg"
            disabled={!isEditing}
          />

          {!isEditing ? (
            <button
              onClick={() => setIsEditing(true)}
              className="bg-yellow-500 text-white px-4 py-2 rounded-lg hover:bg-yellow-600 mb-2"
            >
              Edit
            </button>
          ) : (
            <button
              onClick={handleSave}
              className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 mb-2"
            >
              Save
            </button>
          )}

          <button
            onClick={copyToClipboard}
            className="bg-blue-700 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
          >
            {copied ? "Copied!" : "Copy Account Number"}
          </button>
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center w-96">
          <h2 className="text-2xl font-bold mb-4">My Account</h2>

          <div className="flex justify-center mb-4">
            <QRCodeSVG value={accountNumber} size={150} />
          </div>

          <p className="text-gray-700 font-semibold">Bank Name:</p>
          <p className="mb-2">{bankName}</p>

          <p className="text-gray-700 font-semibold">Account Holder:</p>
          <p className="mb-2">{accountHolder}</p>

          <p className="text-gray-700 font-semibold">Account Number:</p>
          <p className="text-lg font-bold text-blue-600 mb-2">
            {accountNumber}
          </p>

          <button
            onClick={copyToClipboard}
            className="bg-blue-700 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
          >
            {copied ? "Copied!" : "Copy Account Number"}
          </button>
        </div>
      </div>
    );
  }
}

export default DepositTab;
